import {
  CommonIncidentId,
  HandballIncidentId,
} from '@collector/sportsapi-client-legacy'

export const HandballHideIncidentIds = [
  HandballIncidentId.StartDelayed,
  HandballIncidentId.MatchAboutToStart,
  HandballIncidentId.FirstHalfStarted,
  HandballIncidentId.Halftime,
  HandballIncidentId.SecondHalfStarted,
  HandballIncidentId.WaitingForExtratime,
  HandballIncidentId.FirstExtratimeFirstHalfStarted,
  HandballIncidentId.ExtratimeHalftime,
  HandballIncidentId.FirstExtratimeSecondHalfStarted,
  HandballIncidentId.WaitingForSecondExtratime,
  HandballIncidentId.SecondExtratimeFirstHalfStarted,
  HandballIncidentId.SecondExtratimeHalftime,
  HandballIncidentId.SecondExtratimeSecondHalfStarted,
  HandballIncidentId.WaitingForPenalties,
  HandballIncidentId.PenaltyShootoutStarted,
  HandballIncidentId.ToFinish,
  HandballIncidentId.Interrupted,
  HandballIncidentId.Postponed,
  HandballIncidentId.Cancelled,
  HandballIncidentId.FinishedRegularTime,
  HandballIncidentId.FinishedAfterExtratime,
  HandballIncidentId.FinishedAfterPenalties,
  HandballIncidentId.FinishedAwardedWin,
  HandballIncidentId.Abandoned,
  CommonIncidentId.TechnicalProblems,
  CommonIncidentId.Betstart,
  CommonIncidentId.Betstop,
  HandballIncidentId.Goal,
  HandballIncidentId.MissedThrow,
  HandballIncidentId.ThrowSaved,
  HandballIncidentId.ThrowBlocked,
  HandballIncidentId.Turnover,
  HandballIncidentId.Steal,
  HandballIncidentId.Injury,
  HandballIncidentId.Foul,
  HandballIncidentId.YellowCard,
  HandballIncidentId.RedCard,
  HandballIncidentId.BlueCard,
  HandballIncidentId.Penalty,
  HandballIncidentId.MissedPenalty,
  HandballIncidentId.PenaltySaved,
  HandballIncidentId.Timeout,
  HandballIncidentId.TimeoutOver,
  HandballIncidentId.TwoMinuteSuspension,
  HandballIncidentId.SuspensionOver,
  HandballIncidentId.InPossession,
  HandballIncidentId.PassivePlay,
  HandballIncidentId.GoalKeeperBack,
  HandballIncidentId.EmptyNet,
]

export const HandballParticipantIncidentIds = [
  HandballIncidentId.Goal,
  HandballIncidentId.MissedThrow,
  HandballIncidentId.ThrowSaved,
  HandballIncidentId.ThrowBlocked,
  HandballIncidentId.Turnover,
  HandballIncidentId.Steal,
  HandballIncidentId.YellowCard,
  HandballIncidentId.RedCard,
  HandballIncidentId.BlueCard,
  HandballIncidentId.Penalty,
  HandballIncidentId.MissedPenalty,
  HandballIncidentId.PenaltySaved,
  HandballIncidentId.TwoMinuteSuspension,
]

export const HandballSecondParticipantIncidentIds = []

export const HandballDetailsIncidentIds = [
  HandballIncidentId.Goal,
  HandballIncidentId.MissedThrow,
  HandballIncidentId.ThrowSaved,
  HandballIncidentId.ThrowBlocked,
  HandballIncidentId.Turnover,
  HandballIncidentId.Foul,
  HandballIncidentId.PenaltySaved,
]
